// 系统相关接口

/**
 * @description [根据选择的省市县获取县](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/SysController/getCountry)
 * @param {Sys.CityDTO[]} data - 表单数据
 */
export const postSysComRegionGetCountry = (data: Sys.CityDTO[]) =>
  service.post<Res<Sys.ComRegionVO[]>>('/sys/com-region/getCountry', data)

/**
 * @description [根据type和名称获取信息](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/SysController/selectByName)
 * @param {object} params - 根据type和名称获取信息
 */
export const getSysOptionByTypeByName = (params: {
  type: string
  name: string
}) => service.get<Res>(`/sys/option/${params.type}/${params.name}`)

/**
 * @description [根据type获取信息](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/SysController/selectBizOption)
 * @param {object} params - 根据type获取信息
 * @param {string} params.type - type
 */
export const getSysOptionSelectBizoption = (params: {
  type: string
  kw?: string
}) => service.get<Res<Sys.BizOptionVO[]>>('/sys/option/selectBizoption', { params })

/**
 * @description [获取父级下拉选项](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/SysController/getParentOption)
 */
export const getSysOptionParent = () => service.get<Res<Sys.BizOptionVO[]>>('/sys/option/parent')

/**
 * @description [获取列表](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/SysController/getPage_1)
 * @param {object} params - 获取列表
 * @param {number} params.page - page
 * @param {number} params.count - count
 * @param {boolean} params.isShowUiConfig - isShowUiConfig
 */
export const getSysOptionPage = (params: {
  page: number
  count: number
  isShowUiConfig: boolean
}) => service.get<PageRes<Sys.BizOptionVO>>('/sys/option/page', { params })

/**
 * @description [获取级联选项](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/SysController/getCascadeOptions)
 * @param {object} params - 获取级联选项
 * @param {string} params.type - type
 */
export const getSysOptionCascadeOptions = (params: {
  type: string
}) => service.get<Res<Sys.BizOptionVO[]>>('/sys/option/cascade-options', { params })

/**
 * @description [通过id获取区域信息](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/SysController/getRegionDataById)
 * @param {object} params - 通过id获取区域信息
 * @param {string[]} params.regionIdList - regionIdList
 */
export const getSysComRegionRegionData = (params: {
  regionIdList: string[]
}) => service.get<Res<Sys.ComRegionVO[]>>('/sys/com-region/region-data', { params })

/**
 * @description [获取拉下选项--默认懒加载](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/SysController/getStatisticsRegion)
 * @param {object} params - 获取拉下选项--默认懒加载
 * @param {string} [params.type = lazy] - 类型：type 懒加载
 * @param {string} [params.currentId = 0] - currentId
 */
export const getSysComRegionList = (params: {
  type?: string
  currentId?: string
}) => service.get<Res<Sys.ComRegionVO[]>>('/sys/com-region/list', { params })

/**
 * @description [获取拉下选项--默认懒加载](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/SysController/getStatisticsRegion)
 * @param {object} params - 获取拉下选项--默认懒加载
 * @param {string} [params.currentId = 0] - currentId
 */
export const getSysComRegionListContract = (params: {
  currentId?: string
}) => service.get<Res<Sys.ComRegionVO[]>>('/sys/com-region/list/contract', { params })

/**
 * @description [获取到区县的数据](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/SysController/getLevel3Data)
 */
export const getSysComRegionLevel3 = () => service.get<Res<Sys.ComRegionVO[]>>('/sys/com-region/level3')

/**
 * @description [获取懒加载回显数据com_region](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/SysController/getLazyDataWithoutAll)
 * @param {object} params - 获取懒加载回显数据com_region
 * @param {string} params.id - id
 */
export const getSysComRegionLazyDataWithoutAll = (params: {
  id: string
}) => service.get<Res<Sys.ComRegionVO[]>>('/sys/com-region/lazy-data-without-all', { params })

/**
 * @description [获取IP的信息](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/SysController/getIpInfo)
 * @param {object} params - 获取IP的信息
 * @param {string} params.ipAddress - ipAddress
 */
export const getSysComRegionIp = (params: {
  ipAddress: string
}) => service.get<Res<Sys.IpInfoVO>>('/sys/com-region/ip', { params })

/**
 * @description [通过省市区获取完整地址](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/SysController/getRegionName)
 * @param {object} params - 通过省市区获取完整地址
 * @param {string} params.province - province
 * @param {string} params.city - city
 * @param {string} params.county - county
 */
export const getSysComRegionGetRegionName = (params: {
  province: string
  city: string
  county: string
}) => service.get<Res<string>>('/sys/com-region/getRegionName', { params })

/**
 * @description [根据IP获取当前区域](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/SysController/getRegionDataByIP)
 */
export const getSysComRegionGetRegionByIP = () =>
  service.get<Res<Sys.PropertyRegionOptionVO[]>>('/sys/com-region/getRegionByIP')
